export const STATUS_FLOW = [
  "submitted",
  "under_verification",
  "bank_inspection",
  "sanctioned",
  "disbursed",
];

export const STATUS_META = {
  submitted: { label: "Submitted", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  under_verification: { label: "Under Verification", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  bank_inspection: { label: "Bank Inspection", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  sanctioned: { label: "Subsidy Sanctioned", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  disbursed: { label: "Disbursed", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  rejected: { label: "Rejected", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const statusLabel = (s) => STATUS_META[s]?.label || s;
